import React, { Component } from "react";
import './Music-List.css';
import MusicList from "./Music-List";
import { Link } from 'react-router-dom';
import PlaySongs from "./PlaySongs";
import axios from '../tokenInterceptor';

class PrimeStations extends Component {
    constructor(props) {
        super(props);
        this.state={
            itemDescriptions:{},
            hide:false,
            topCountrySongs:[],
            topSalsaSongs:[],
            topUltimateClassicalSongs:[],
            selectedMusic:{},
            topPopSongs:[],
            lullabiesBedtimeMusic:[],
            topChristian:[],
            classicRock:[],
            smoothJazz: [],
            mellowFolk:[],
            meditation:[]
        }
    }

    componentWillMount =()=>{
        this.checkTokenExpire();
    }

    getPrimeStations=()=>{
        axios.get("/getPrimeStations").then((res)=>{
            if(res.data.status == 200) {
                this.setState({itemDescriptions:res.data.data, hide:true});
                this.getTopCountrySongs();
            } else {
                this.setState({itemDescriptions:{}})
            }
        })
    }

    getTopCountrySongs =()=>{
        axios.get("/getTopCountrySongs").then((res)=>{
            if(res.data.status == 200) {
                let td = res.data.data.trackDefinitions;
                let num = Object.keys(td).length;
                let topCountrySongsContents =[]
                for(let i=0; i<num; i++) {
                let key = "def_"+i;
                let data = td[key];
                topCountrySongsContents.push(data);
                };
                this.getTopSalsaSongs();
                this.setState({topCountrySongs:topCountrySongsContents});    
            } else {
                this.setState({topCountrySongs:[]});
            }
        })
    }

    getTopSalsaSongs =()=>{
        axios.get("/getTopSalsaSongs").then((res)=>{
            if(res.data.status == 200) {
                let td = res.data.data.trackDefinitions;
                let num = Object.keys(td).length;
                let topSalsaSongsContents =[]
                for(let i=0; i<num; i++) {
                let key = "def_"+i;
                let data = td[key];
                topSalsaSongsContents.push(data);
                };
                this.getUltimateClassicalSongs();
                this.setState({topSalsaSongs:topSalsaSongsContents});    
            } else {
                this.setState({topSalsaSongs:[]});
            }
        })
    }

    getUltimateClassicalSongs =()=>{
        axios.get("/getUltimateClassicalSongs").then((res)=>{
            if(res.data.status == 200) {
                let td = res.data.data.trackDefinitions;
                let num = Object.keys(td).length;
                let topUltimateClassicalSongsContents =[]
                for(let i=0; i<num; i++) {
                let key = "def_"+i;
                let data = td[key];
                topUltimateClassicalSongsContents.push(data);
                };
                this.getTopPopSongs();
                this.setState({topUltimateClassicalSongs:topUltimateClassicalSongsContents});    
            } else {
                this.setState({topUltimateClassicalSongs:[]});
            }
        })
    }

    getTopPopSongs =()=>{
        axios.get("/getTopPopSongs").then((res)=>{
            if(res.data.status == 200) {
                let td = res.data.data.trackDefinitions;
                let num = Object.keys(td).length;
                let topPopSongsContents =[]
                for(let i=0; i<num; i++) {
                let key = "def_"+i;
                let data = td[key];
                topPopSongsContents.push(data);
                };
                this.getLullabiesBedtimeMusic();
                this.setState({topPopSongs:topPopSongsContents});    
            } else {
                this.setState({topPopSongs:[]});
            }
        })
    }

    getLullabiesBedtimeMusic =()=>{
        axios.get("/getLullabiesBedtimeMusic").then((res)=>{
            if(res.data.status == 200) {
                let td = res.data.data.trackDefinitions;
                let num = Object.keys(td).length;
                let lullabiesBedtimeMusicContents =[]
                for(let i=0; i<num; i++) {
                let key = "def_"+i;
                let data = td[key];
                lullabiesBedtimeMusicContents.push(data);
                };
                this.getTopChristian();
                this.setState({lullabiesBedtimeMusic:lullabiesBedtimeMusicContents});    
            } else {
                this.setState({lullabiesBedtimeMusic:[]});
            }
        })
    }

    getTopChristian =()=>{
        axios.get("/getTopChristian").then((res)=>{
            if(res.data.status == 200) {
                let td = res.data.data.trackDefinitions;
                let num = Object.keys(td).length;
                let topChristianContents =[]
                for(let i=0; i<num; i++) {
                let key = "def_"+i;
                let data = td[key];
                topChristianContents.push(data);
                };
                this.getClassicRock();
                this.setState({topChristian:topChristianContents});    
            } else {
                this.setState({topChristian:[]});
            }
        })
    }

    getClassicRock =()=>{
        axios.get("/getClassicRock").then((res)=>{
            if(res.data.status == 200) {
                let td = res.data.data.trackDefinitions;
                let num = Object.keys(td).length;
                let classicRockContents =[]
                for(let i=0; i<num; i++) {
                let key = "def_"+i;
                let data = td[key];
                classicRockContents.push(data);
                };
                this.getSmoothJazz();
                this.setState({classicRock: classicRockContents});    
            } else {
                this.setState({classicRock:[]});
            }
        })
    }

    getSmoothJazz =()=>{
        axios.get("/getSmoothJazz").then((res)=>{
            if(res.data.status == 200) {
                let td = res.data.data.trackDefinitions;
                let num = Object.keys(td).length;
                let smoothJazzContents =[]
                for(let i=0; i<num; i++) {
                let key = "def_"+i;
                let data = td[key];
                smoothJazzContents.push(data);
                };
                this.getMellowFolk()
                this.setState({smoothJazz: smoothJazzContents});    
            } else {
                this.setState({smoothJazz:[]});
            }
        })
    }

    getMellowFolk =()=>{
        axios.get("/getMellowFolk").then((res)=>{
            if(res.data.status == 200) {
                let td = res.data.data.trackDefinitions;
                let num = Object.keys(td).length;
                let mellowFolkContents =[]
                for(let i=0; i<num; i++) {
                let key = "def_"+i;
                let data = td[key];
                mellowFolkContents.push(data);
                };
                this.getMeditation();
                this.setState({mellowFolk: mellowFolkContents});    
            } else {
                this.setState({mellowFolk:[]});
            }
        })
    }

    getMeditation =()=>{
        axios.get("/getMeditation").then((res)=>{
            if(res.data.status == 200) {
                let td = res.data.data.trackDefinitions;
                let num = Object.keys(td).length;
                let meditationContents =[]
                for(let i=0; i<num; i++) {
                let key = "def_"+i;
                let data = td[key];
                meditationContents.push(data);
                };
                this.setState({meditation: meditationContents});    
            } else {
                this.setState({meditation:[]});
            }
        })
    }

    setMusic=(data)=>{
        let selectedMusic= this.state.selectedMusic;
        selectedMusic.title = data.album.name;
        selectedMusic.artist = data.artist.name;
        selectedMusic.imageUrl = data.image.uri;
        selectedMusic.songUrl = data.audio.uri;
        this.setState({selectedMusic:selectedMusic});
    }

    generateNewAccessToken() {
        var requestObject = {
          "grant_type": "refresh_token",
          "refresh_token": localStorage.getItem("refresh_token"),
          "client_id": "amzn1.application-oa2-client.be6fd65f44a24c7dabec6f1e78c0fbd9",
          "client_secret": "9ceb5c037d0d032d62fd09e64b4784dfd06ec22cae72e15cb9b9e1690e3bfe05"
        };
        axios.post("generateToken", requestObject).then((res)=>{
            if(res.status ==200) {
                var currentTime   = new Date();
                this.tokenGetTime=  currentTime.getTime();
                localStorage.setItem('auth-token', res.data.data.access_token);
                localStorage.setItem('expire', 3600);
                localStorage.setItem('tokenFetchTime', this.tokenGetTime);
                localStorage.setItem('refresh_token', res.data.data.refresh_token);
                this.getPrimeStations();
            } else {
                console.log("unable t generate token");
            }
        });
    }

    checkTokenExpire=()=>{
        var currentTime   = new Date();
        this.tokenGetTime=  localStorage.getItem('tokenFetchTime');
        if((currentTime.getTime() - this.tokenGetTime)/1000 < 3600) {
            this.getPrimeStations();
        } else {
            this.generateNewAccessToken();
        }
    }

    render() {
        return (
            <>
                <div className="right-section">
                    <div className="main-page">
                    {
                        this.state.hide && (
                            <div>
                                <div className="top-playlist">
                                    <h3 className="heading">{this.state.itemDescriptions.itemDescriptions.station_2_desc.itemLabel}</h3>
                                    <hr/>
                                    <ul>
                                        {this.state.topCountrySongs.map((data, index)=>{
                                            return <li key={index} className="song-title">
                                                <img src={data.image.uri} style={{"width":"50px", "height":"50px"}}/>
                                                <a className="title" style={{"cursor": "pointer"}} onClick={()=>this.setMusic(data)}>{data.title}</a>
                                            </li>
                                        })}
                                    </ul>
                                </div>
                                <div className="top-playlist">
                                    <h3 className="heading">{this.state.itemDescriptions.itemDescriptions.station_3_desc.itemLabel}</h3>
                                    <hr/>
                                    <ul>
                                        {this.state.topSalsaSongs.map((data, index)=>{
                                            return <li key={index} className="song-title">
                                                <img src={data.image.uri} style={{"width":"50px", "height":"50px"}}/>
                                                <a className="title" style={{"cursor": "pointer"}} onClick={()=>this.setMusic(data)}>{data.title}</a>
                                            </li>
                                        })}
                                    </ul>
                                </div>
                                <div className="top-playlist">
                                    <h3 className="heading">{this.state.itemDescriptions.itemDescriptions.station_4_desc.itemLabel}</h3>
                                    <hr/>
                                    <ul>
                                        {this.state.topUltimateClassicalSongs.map((data, index)=>{
                                            return <li key={index} className="song-title">
                                                <img src={data.image.uri} style={{"width":"50px", "height":"50px"}}/>
                                                <a className="title" style={{"cursor": "pointer"}} onClick={()=>this.setMusic(data)}>{data.title}</a>
                                            </li>
                                        })}
                                    </ul>
                                </div>
                                <div className="top-playlist">
                                    <h3 className="heading">{this.state.itemDescriptions.itemDescriptions.station_5_desc.itemLabel}</h3>
                                    <hr/>
                                    <ul>
                                        {this.state.topPopSongs.map((data, index)=>{
                                            return <li key={index} className="song-title">
                                                <img src={data.image.uri} style={{"width":"50px", "height":"50px"}}/>
                                                <a className="title" style={{"cursor": "pointer"}} onClick={()=>this.setMusic(data)}>{data.title}</a>
                                            </li>
                                        })}
                                    </ul>
                                </div>
                                <div className="top-playlist">
                                    <h3 className="heading">{this.state.itemDescriptions.itemDescriptions.station_6_desc.itemLabel}</h3>
                                    <hr/>
                                    <ul>
                                        {this.state.lullabiesBedtimeMusic.map((data, index)=>{
                                            return <li key={index} className="song-title">
                                                <img src={data.image.uri} style={{"width":"50px", "height":"50px"}}/>
                                                <a className="title" style={{"cursor": "pointer"}} onClick={()=>this.setMusic(data)}>{data.title}</a>
                                            </li>
                                        })}
                                    </ul>
                                </div>
                                <div className="top-playlist">
                                    <h3 className="heading">{this.state.itemDescriptions.itemDescriptions.station_7_desc.itemLabel}</h3>
                                    <hr/>
                                    <ul>
                                        {this.state.topChristian.map((data, index)=>{
                                            return <li key={index} className="song-title">
                                                <img src={data.image.uri} style={{"width":"50px", "height":"50px"}}/>
                                                <a className="title" style={{"cursor": "pointer"}} onClick={()=>this.setMusic(data)}>{data.title}</a>
                                            </li>
                                        })}
                                    </ul>
                                </div>
                                <div className="top-playlist">
                                    <h3 className="heading">{this.state.itemDescriptions.itemDescriptions.station_8_desc.itemLabel}</h3>
                                    <hr/>
                                    <ul>
                                        {this.state.classicRock.map((data, index)=>{
                                            return <li key={index} className="song-title">
                                                <img src={data.image.uri} style={{"width":"50px", "height":"50px"}}/>
                                                <a className="title" style={{"cursor": "pointer"}} onClick={()=>this.setMusic(data)}>{data.title}</a>
                                            </li>
                                        })}
                                    </ul>
                                </div>
                                <div className="top-playlist">
                                    <h3 className="heading">{this.state.itemDescriptions.itemDescriptions.station_9_desc.itemLabel}</h3>
                                    <hr/>
                                    <ul>
                                        {this.state.smoothJazz.map((data, index)=>{
                                            return <li key={index} className="song-title">
                                                <img src={data.image.uri} style={{"width":"50px", "height":"50px"}}/>
                                                <a className="title" style={{"cursor": "pointer"}} onClick={()=>this.setMusic(data)}>{data.title}</a>
                                            </li>
                                        })}
                                    </ul>
                                </div>
                                <div className="top-playlist">
                                    <h3 className="heading">{this.state.itemDescriptions.itemDescriptions.station_10_desc.itemLabel}</h3>
                                    <hr/>
                                    <ul>
                                        {this.state.mellowFolk.map((data, index)=>{
                                            return <li key={index} className="song-title">
                                                <img src={data.image.uri} style={{"width":"50px", "height":"50px"}}/>
                                                <a className="title" style={{"cursor": "pointer"}} onClick={()=>this.setMusic(data)}>{data.title}</a>
                                            </li>
                                        })}
                                    </ul>
                                </div>
                                <div className="top-playlist">
                                    <h3 className="heading">{this.state.itemDescriptions.itemDescriptions.station_11_desc.itemLabel}</h3>
                                    <hr/>
                                    <ul>
                                        {this.state.meditation.map((data, index)=>{
                                            return <li key={index} className="song-title">
                                                <img src={data.image.uri} style={{"width":"50px", "height":"50px"}}/>
                                                <a className="title" style={{"cursor": "pointer"}} onClick={()=>this.setMusic(data)}>{data.title}</a>
                                            </li>
                                        })}
                                    </ul>
                                </div>

                                
                                {/* <h3 className="heading">{this.state.itemDescriptions.station_5_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_6_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_7_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_8_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_9_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_10_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_11_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_12_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_13_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_14_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_15_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_16_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_17_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_18_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_19_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_20_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_21_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_22_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_23_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_24_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_25_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_26_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_27_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_28_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_29_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_30_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_31_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_32_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_33_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_34_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_35_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_36_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_37_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_38_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_39_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_40_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_41_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_42_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_43_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_44_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_45_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_46_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_47_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_48_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_49_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_50_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_51_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_52_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_53_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_54_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_55_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_56_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_57_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_58_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_59_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_60_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_61_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_62_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_63_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_64_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_65_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_66_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_67_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_68_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_69_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_70_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_71_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_72_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_73_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_74_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_75_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_76_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_77_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_78_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_79_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_80_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_81_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_82_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_83_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_84_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_85_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_86_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_87_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_88_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_89_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_90_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_91_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_92_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_93_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_94_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_95_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_96_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_97_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_98_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_99_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_100_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.station_101_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.browse_filter_allStations_0_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.browse_filter_artistsAZ_1_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.browse_filter_0_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.browse_filter_1_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.browse_filter_2_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.browse_filter_3_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.browse_filter_4_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.browse_filter_5_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.browse_filter_6_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.browse_filter_7_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.browse_filter_8_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.browse_filter_9_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.browse_filter_10_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.browse_filter_11_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.browse_filter_12_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.browse_filter_13_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.browse_filter_14_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.browse_filter_15_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.browse_filter_16_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.browse_filter_17_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.browse_filter_18_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.browse_filter_19_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.browse_filter_20_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.browse_filter_21_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.browse_filter_22_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.browse_filter_23_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.browse_filter_24_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.browse_filter_25_desc.itemLabel}</h3>
                                <h3 className="heading">{this.state.itemDescriptions.browse_filter_26_desc.itemLabel}</h3> */}
                            </div>
                        )
                    }
                    <PlaySongs
                        music={this.state.selectedMusic}
                    />
                    </div>
                </div>
            </>
        )
    }
}

export default PrimeStations;
